import HeroBackgroundImage from './App'
import { reactToCwp } from '../../../../../common/react-utils'

export default reactToCwp(HeroBackgroundImage)
